// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_a3H","cls2":"JournalSubscriptionPage-cls2_EX- JournalSubscriptionPage-cls1_a3H"};